
<button *ngIf="isBackButtonVisible" (click)="onBackButtonClicked()" class="copo-back-icon" type="button" mat-icon-button title="Previous">
	<mat-icon svgIcon="md:chevron_left"></mat-icon>
</button>

<div class="page-header-title">
	<span [class.page-header-title-part]="isBackButtonVisible">{{ titleHeaderText }}</span>
	<ng-container *ngIf="pathHeaderText">
		<span class="page-header-title-part separator">{{ headerTextSeparator }}</span>
		<span class="page-header-title-part">{{ pathHeaderText }}</span>
	</ng-container>
	<ng-container *ngIf="detailsHeaderText">
		<span class="page-header-title-part separator">{{ headerTextSeparator }}</span>
		<span class="page-header-title-part">{{ detailsHeaderText }}</span>
	</ng-container>
</div>

<ng-content></ng-content>